import { Badge } from '@/shared/components/Badge'

// ── Findings list ────────────────────────────────────────────────────────────
// One table for every finding category, with a segmented filter over it. The five separate
// tables this replaces each named their columns after FIELDS, which could not survive being
// merged: `title` is a detector name, a hostname and a prebuilt sentence depending on category,
// and `resource` is sometimes a TF address and sometimes a bare host. Columns here are named
// after the QUESTION they answer, and lib/findingView.ts answers it per category.
export function VerificationBadge({ state }: { state: 'live' | 'failed' }) {
  return state === 'live'
    ? <Badge variant="red">Live credential</Badge>
    : <Badge variant="neutral">Verification failed</Badge>
}

